"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DataDatabaseIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.24 16c.93 1.368 4.443 2.385 8.635 2.385S19.581 17.368 20.51 16c.133.197.213.4.234.61h.006v2.219h-.005c-.156 1.787-4.067 3.217-8.87 3.217-4.803 0-8.714-1.43-8.87-3.217H3V16.61h.006c.02-.21.1-.413.234-.61zm-.036-5.7c.87 1.396 4.422 2.44 8.671 2.44s7.8-1.044 8.67-2.44c.135.214.205.437.205.666 0 .074-.008.148-.022.222h.022v1.775h-.005c.003.036.005.073.005.11 0 1.839-3.973 3.329-8.875 3.329S3 14.912 3 13.073c0-.037.002-.074.005-.11H3v-1.775h.022A1.12 1.12 0 013 10.966c0-.229.07-.452.204-.666z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.744 4.995h.006v2.22h-.005c.003.036.005.073.005.11 0 1.838-3.973 3.328-8.875 3.328S3 9.163 3 7.325c0-.037.002-.074.005-.11H3v-2.22h.006C3.172 3.331 7.08 2 11.875 2s8.703 1.331 8.87 2.995z"
  })));
});
DataDatabaseIcon.category = 'Content';
var _default = DataDatabaseIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/DataDatabaseIcon.js
// module id = 1066
// module chunks = 0